module.exports = __webpack_public_path__ + "dd4316583ac85be9563456fda360285f.pdf";